exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".JMpht{padding:25px}._3xToS,.JMpht{text-align:center}._3xToS{font-family:Roboto,sans-serif;font-size:20px;color:#363636;height:24px}._3xToS a{color:#eb0000}", ""]);

// exports
exports.locals = {
	"divImagen": "JMpht",
	"divTexto": "_3xToS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/SinHorariosDisponibles/SinHorariosDisponibles.css
// module id = 1284
// module chunks = 0 1